import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";

const state = {
  checking: false,
  user: null,
  errors: null,
  isAuthenticated: !!JwtService.getToken(),
  
};

const actions = {
  login(context, credentials) {
    return new Promise(resolve => {
      console.log("Going to login");
      ApiService.post("login", credentials )
        .then(({ data }) => {
          context.commit("setAuth", data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("setError", response.data.errors);
        });
    });
  },
  logout(context) {
    context.commit("purgeAuth");
    context.dispatch("gateways/saveCurrentGateway", null, {root: true});
  },
  check(context) {
    if (JwtService.getToken()) {
      context.commit('checking', true);
      return new Promise((resolve, reject) => {
        try {
          ApiService.setAgent();
          ApiService.setHeader();
          ApiService.get("user")
          .then(({ data }) => {
            console.log(data)
            context.commit("setAuth", data);
            resolve(data);
            context.commit('checking', false);
          })
          .catch((error) => {
            context.commit("setError", error.message);
            context.commit("purgeAuth");
            reject(error);
            context.commit('checking', false);
          });
        } catch (error) {

          context.commit("setError", error.message);
          context.commit("purgeAuth");
          reject(error);
          context.commit('checking', false);
      }
      });   

    } else {
      return new Promise((resolve, reject, onCancel) => {
        context.commit("purgeAuth");
        reject("No token avalable")
      });
      
    }
  },
};

const mutations = {
  setError(state, error) {
    state.errors = error;
  },
  setAuth(state, data) {
    state.isAuthenticated = true;
    state.user = data;
    state.errors = {};
    JwtService.saveToken(data.jwt);
    console.log('Saved token ', data);
  },
  purgeAuth(state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    
  },
  checking(state, value) {
    state.checking = value;
    
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};